export default function Footer(){
    return(
        <>
            <footer className="footer">
            <div className="container-fluid d-flex justify-content-between">
                <nav className="pull-left">
                <ul className="nav">
                    <li className="nav-item">
                    <a className="nav-link" href="https://www.o7services.com">
                        O7 Services
                    </a>
                    </li>
                </ul>
                </nav>
                <div className="copyright">
                2025, made with <i className="fa fa-heart heart text-danger" /> by
                <a href="http://www.o7services.com"> O7 Services</a>
                </div>
                <div>
                
                </div>
            </div>
            </footer>
        </>
    )
}